var map = {
	"./404.svg": 973,
	"./Categories.png": 723,
	"./Edit-menu.svg": 974,
	"./Egg.svg": 975,
	"./Emaier-Header.png": 976,
	"./Qr-4.png": 977,
	"./_duplicate.svg": 978,
	"./_overview.svg": 979,
	"./add-white.svg": 980,
	"./alert.svg": 981,
	"./all_category.svg": 982,
	"./archive.svg": 983,
	"./armchair.svg": 984,
	"./arrow-circle-right.svg": 985,
	"./arrow-left-circle.svg": 986,
	"./arrow-right-circle.svg": 987,
	"./arrow-right.svg": 988,
	"./asc-up-white.svg": 989,
	"./asc.png": 990,
	"./asc.svg": 991,
	"./back-arrow.svg": 992,
	"./barcode-icon.svg": 993,
	"./beverages.svg": 994,
	"./blue-edit-pen.svg": 995,
	"./blue-eye.svg": 996,
	"./box-office.svg": 997,
	"./broken-seat.jpg": 998,
	"./calendar_list.svg": 999,
	"./calender.svg": 369,
	"./chevron-down.svg": 1000,
	"./chevron-left.svg": 1001,
	"./cinema-mamagement-sidebar.svg": 1002,
	"./claendar.svg": 317,
	"./clock-1.svg": 1003,
	"./clock.svg": 1004,
	"./close-button.svg": 730,
	"./close-white.svg": 736,
	"./close-x.svg": 312,
	"./collapse-up.svg": 1005,
	"./collapse.svg": 1006,
	"./connection-lost.svg": 367,
	"./consumable-raw-material.svg": 1007,
	"./copy.svg": 1008,
	"./copy_image_icon.png": 1009,
	"./delete-red-light.svg": 1010,
	"./delete-red.svg": 737,
	"./delete.svg": 711,
	"./deliver-icon.svg": 1011,
	"./desc-down-white.svg": 1012,
	"./desc.svg": 1013,
	"./distributors-sidebar.svg": 1014,
	"./download.svg": 1015,
	"./dragndrop.svg": 1016,
	"./dragndrop2.svg": 1017,
	"./duplicate.svg": 1018,
	"./duplicateScreen.svg": 1019,
	"./e-wallet-icon-black.svg": 1020,
	"./edit-pen-blue.svg": 1021,
	"./edit-pen-white.svg": 1022,
	"./edit-pen.svg": 1023,
	"./edit.svg": 1024,
	"./email.png": 1025,
	"./empty-image.svg": 1026,
	"./excel.svg": 1027,
	"./external-link.svg": 1028,
	"./eye.svg": 1029,
	"./filter-icon.svg": 1030,
	"./flag.svg": 1031,
	"./fnb-app-order.svg": 1032,
	"./fnb-beverages.svg": 1033,
	"./fnb-brownie.svg": 1034,
	"./fnb-combo.svg": 1035,
	"./fnb-desert.svg": 1036,
	"./fnb-eatables.svg": 1037,
	"./fnb-make-your-combo.svg": 1038,
	"./fnb-popcorn.svg": 1039,
	"./fnbtransactionIcon.svg": 1040,
	"./fullscreen-icon.svg": 738,
	"./funnel.svg": 1041,
	"./globe.svg": 1042,
	"./green-tick.svg": 1043,
	"./grid-view.svg": 1044,
	"./hide-password.svg": 370,
	"./home-icon.svg": 1045,
	"./home.svg": 1046,
	"./icon-black-play.svg": 1047,
	"./icon-dot.svg": 1048,
	"./icon-fnb.svg": 1049,
	"./icon-marketing.svg": 1050,
	"./icon-no-seat.png": 1051,
	"./icon-no-seat.svg": 1052,
	"./icon-option.svg": 1053,
	"./icon-poin-of-sale.svg": 1054,
	"./icon-recliner.svg": 1055,
	"./icon-report.svg": 1056,
	"./icon-sofa-dark-1.svg": 1057,
	"./icon-sofa-dark.png": 1058,
	"./icon-sofa-dark.svg": 1059,
	"./icon-sofa.svg": 1060,
	"./importfile.svg": 1061,
	"./info.svg": 739,
	"./info2.svg": 1062,
	"./keyboard-icon.svg": 1063,
	"./kitchen_display.svg": 1064,
	"./language-icon.svg": 371,
	"./left-caret.svg": 1065,
	"./link.svg": 1066,
	"./list-view.svg": 1067,
	"./loading.svg": 372,
	"./lock.svg": 1068,
	"./login-password.png": 373,
	"./login-user.png": 374,
	"./logout.svg": 740,
	"./masters-sidebar.svg": 1069,
	"./merchandise.svg": 1070,
	"./minus.svg": 1071,
	"./movie-pass-svg.svg": 721,
	"./movie-rolling.svg": 1072,
	"./mulitSchedule.svg": 1073,
	"./multicurrency.svg": 1074,
	"./multifnb.svg": 1075,
	"./nav-plus.svg": 1076,
	"./new_filter_icon.svg": 1077,
	"./no-image.svg": 1078,
	"./no-schedule.svg": 144,
	"./non-veg-mark.png": 1079,
	"./non-veg-mark.svg": 1080,
	"./notification.svg": 1081,
	"./open-link-blue.svg": 1082,
	"./openPlanned.svg": 1083,
	"./overview.svg": 1084,
	"./overview2.svg": 1085,
	"./pdf-icon.svg": 1086,
	"./pdf.svg": 1087,
	"./pickup-ticket-icon.svg": 1088,
	"./pickupfnb.svg": 1089,
	"./play.svg": 1090,
	"./plus.svg": 1091,
	"./pointofsale-1.svg": 1092,
	"./pointofsale-2.svg": 1093,
	"./pointofsale.png": 1094,
	"./portfolio.svg": 1095,
	"./pos-fnb-no-itmes.svg": 724,
	"./pos-refresh.svg": 1096,
	"./primary/chevron-down.svg": 1097,
	"./primary/download.svg": 1098,
	"./primary/edit.svg": 1099,
	"./primary/filter.svg": 1100,
	"./primary/printer.svg": 1101,
	"./print-icon.svg": 1102,
	"./print.svg": 1103,
	"./question.svg": 1104,
	"./question1.svg": 1105,
	"./question2.svg": 741,
	"./question3.svg": 1106,
	"./recliner-1.svg": 1107,
	"./recliner.png": 1108,
	"./refund-icon.svg": 1109,
	"./reload-icon-pos.svg": 1110,
	"./reload-icon.svg": 1111,
	"./restore.svg": 1112,
	"./right-caret.svg": 1113,
	"./role-management-sidebar.svg": 1114,
	"./save.svg": 1115,
	"./schedule-icon.svg": 1116,
	"./school-calendar.svg": 1117,
	"./search-global-white.svg": 1118,
	"./search-global.svg": 1119,
	"./search.svg": 742,
	"./searchIcon.svg": 1120,
	"./seat-icon-2.svg": 1121,
	"./seat-icon.svg": 1122,
	"./seat-icons/3-wheelChair.png": 1123,
	"./seat-icons/block_seat_new.png": 1124,
	"./seat-icons/broken-seat-1.svg": 1125,
	"./seat-icons/broken-seat-2.svg": 1126,
	"./select-food.png": 743,
	"./settings.svg": 1127,
	"./show-password.svg": 375,
	"./slider-triangle.svg": 732,
	"./snack.svg": 744,
	"./sort.svg": 1128,
	"./star-empty.svg": 1129,
	"./star-fill.svg": 1130,
	"./success-tick.svg": 1131,
	"./suitcase.svg": 1132,
	"./swap.svg": 1133,
	"./tick-green-item.svg": 745,
	"./tick-green.svg": 1134,
	"./ticket-icon.svg": 1135,
	"./trash.svg": 1136,
	"./unpaid-reservation.svg": 715,
	"./updown-white.svg": 1137,
	"./updown.svg": 1138,
	"./user-attribute.svg": 1139,
	"./user-attributes.svg": 1140,
	"./user-female.svg": 1141,
	"./user-male-white.svg": 1142,
	"./user-male.svg": 1143,
	"./user-profile.svg": 1144,
	"./userProfile.png": 1145,
	"./veg-food-mark-white.png": 1146,
	"./veg-foog-mark-trans.png": 1147,
	"./view.png": 1148,
	"./view.svg": 1149
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 972;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 972
// module chunks = 38